<template>
  <div class="w-full">
    <div class="flex flex-col md:flex-row">
      <div class="w-full">
        <div class="flex flex-1 flex-row justify-between p-5">
          <markdown
            :content="description"
            class="text-right"
            inherit-styles
          />
        </div>
        <div v-if="step.steppable?.documents?.length > 0" class="flex flex-row space-x-4 p-4">
          <PathwayDocumentCard
            v-for="document in step.steppable.documents"
            :key="document.id"
            :consumer-key="consumerKey"
            :document="document"
          />
        </div>
        <div v-if="step.consent" class="my-4">
          <PathwayStepConsent :consent="step.consent" :consumer-key="consumerKey" />
        </div>
        <div class="flex flex-row justify-end px-5 pb-5">
          <BaseButton
            :primary="true"
            :loading="loading"
            class="text-sm font-semibold"
            @click="$emit('finish')"
          >
            {{ step.action ?? 'Document remis' }}
          </BaseButton>
        </div>
      </div>
    </div>
    <PathwayStepInsert
      v-if="active"
      :step="step"
    />
  </div>
</template>

<script lang="ts" setup>
import {computed} from "vue";
import Markdown from '@/core/components/markdown/Markdown.vue';
import BaseButton from '@/core/components/base/BaseButton.vue';
import PathwayStepInsert from '@/pathway/components/PathwayStepInsert.vue';
import PathwayDocumentCard from '@/pathway/components/PathwayDocumentCard.vue';
import {Pathway, PathwayStep} from "@/program/interfaces/Program";
import PathwayStepConsent from "@/pathway/components/PathwayStepConsent.vue";

defineEmits<{
    (e: 'finish'): void;
}>();

const props = defineProps<{
    pathway: Pathway;
    step: PathwayStep;
    consumerKey: string;
    loading?: boolean;
    active?: boolean;
}>();

const description = computed(() => props.step.resolved.description);
</script>
